import React, { useRef, useState } from 'react';
import TornadoChart from '../components/Tornado/TornadoChart';
import theme from '../theme';

function TornadoPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/data-vis/upload-tornado', {
        method: 'POST',
        body: formData,
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        setData(null);
        setError(result.detail || `Upload failed (${response.status})`);
        return;
      }
      const toBars = (rows, col) => rows.map(item => ({
        Strike: item.Strike,
        Calls: item.Type === 'Call' ? -Math.abs(item[col]) : 0,
        Puts: item.Type === 'Put' ? Math.abs(item[col]) : 0,
      }));
      const m = result.metadata;

      setData({
        volumeData: toBars(result.volumeData, 'DollarVolume'),
        oiData: toBars(result.oiData, 'OIDollar'),
        filename: m?.filename,
        DateGeneration: m?.DateGeneration,
        dollarVolumeCalls: m?.dollarVolumeCalls,
        dollarVolumePuts: m?.dollarVolumePuts,
        oiDollarCalls: m?.oiDollarCalls,
        oiDollarPuts: m?.oiDollarPuts,
      });
    } catch (error) {
      console.error('Error uploading file:', error);
      setData(null);
      setError('Error uploading file');
    } finally {
      setLoading(false);
      e.target.value = '';
    }
  };

  const triggerFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className={`container mx-auto px-4 py-8 ${theme.pageBg} min-h-screen`}>
      <h1 className={`text-2xl font-bold mb-4 ${theme.textPrimary}`}>Tornado Graphs</h1>
      <button
        onClick={triggerFileUpload}
        className={`py-2 px-4 rounded-xl font-bold text-sm ${theme.btnPrimary}`}
      >
        Choose .csv file
      </button>
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileUpload}
        className="hidden"
      />
      {loading && <p className={`mt-4 ${theme.textSecondary}`}>Loading...</p>}
      {error && <p role="alert" className="mt-4 text-red-500">{error}</p>}
      {data && (
        <TornadoChart {...data} />
      )}
    </div>
  );
}

export default TornadoPage;